import React from 'react';

import { EColor } from '../Theme';

export const SMSIcon = () => (
  <svg
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 18.2895V3C1 1.89543 1.89543 1 3 1H17C18.1046 1 19 1.89543 19 3V13C19 14.1046 18.1046 15 17 15H5.96125C5.35368 15 4.77906 15.2762 4.39951 15.7506L2.06852 18.6643C1.71421 19.1072 1 18.8567 1 18.2895Z"
      stroke={EColor.Black}
      strokeWidth="2"
    />
  </svg>
);
